import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';

const InternalRetailPartsTable = ({
    th,
    data,
    totalRecords,
    lazyParams,
    onPage,
    onSort,
    loading,
    onViewDetail
}) => {
    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString('tr-TR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const formatCurrency = (value) => {
        if (value == null) return '-';
        return value.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const actionTemplate = (rowData) => (
        <Button
            icon="pi pi-pencil"
            rounded
            text
            severity="info"
            onClick={() => onViewDetail(rowData)}
            tooltip={th('internalRetailParts.detailTitle') || 'Detay'}
            tooltipOptions={{ position: 'top' }}
        />
    );

    return (
        <DataTable
            value={data}
            lazy
            paginator
            first={lazyParams.first}
            rows={lazyParams.rows}
            totalRecords={totalRecords}
            onPage={onPage}
            onSort={onSort}
            sortField={lazyParams.sortField}
            sortOrder={lazyParams.sortOrder}
            loading={loading}
            rowsPerPageOptions={[10, 20, 50]}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate={th('table.paginatorTemplate')}
            emptyMessage={th('common.noRecords') || 'Kayıt bulunamadı'}
            stripedRows
            showGridlines
            size="small"
            dataKey="id"
        >
            <Column
                body={actionTemplate}
                header=""
                style={{ width: '60px', textAlign: 'center' }}
                frozen
            />
            <Column
                field="id"
                header="ID"
                style={{ width: '80px' }}
                sortable
            />
            <Column
                field="senderDealer"
                header={th('internalRetailParts.senderDealer') || 'Gönderen Bayi'}
                body={(row) => row.senderDealer || '-'}
                sortable
            />
            <Column
                field="receiverDealer"
                header={th('internalRetailParts.receiverDealer') || 'Alıcı Bayi'}
                body={(row) => row.receiverDealer || '-'}
                sortable
            />
            <Column
                field="totalAmount"
                header={th('internalRetailParts.totalAmount') || 'Toplam Tutar'}
                body={(row) => formatCurrency(row.totalAmount)}
                style={{ width: '150px', textAlign: 'right' }}
                sortable
            />
            <Column
                field="createdDate"
                header={th('internalRetailParts.createdDate') || 'Oluşturma Tarihi'}
                body={(row) => formatDate(row.createdDate)}
                style={{ width: '180px' }}
                sortable
            />
        </DataTable>
    );
};

export default InternalRetailPartsTable;

